const isAbsent = value => value == null;

export default isAbsent;


//////////////////
// WEBPACK FOOTER
// ./~/yup/es/util/isAbsent.js
// module id = 61
// module chunks = 14